export default {
  loading: false,
  orderList: [],
  menuList:[],
  message:"",
  orderhistory:[]
};
